import { setTimeActivity as setTimeActivityDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    activity?: Number,
}

export const setTimeActivity = ({
    activity,
    eventEmitter
}: Props) => {
    setTimeActivityDiagram(activity);
};



